/* Português (Brasil) */
const ptBr = {
  nav: {
    home: 'Início',
    imageConverter: 'Conversor de Imagens',
    imageCompressor: 'Compressor de Imagens',
    otherTools: 'Outras Ferramentas',
    resizeImage: 'Redimensionar Imagem',
    cropImage: 'Cortar Imagem',
    photoEditor: 'Editor de Fotos',
    removeBackground: 'Remover Fundo',
    watermarkImage: 'Marca d\'Água',
    qrCodeGenerator: 'Gerador de QR Code',
    qrCodeScanner: 'Leitor de QR Code',
    aboutUs: 'Sobre Nós',
    faceBlur: 'Desfocar Rosto',
  },
  hero: {
    heading: 'Todas as Ferramentas de Imagem que Você Precisa',
    subheading: 'Ferramentas online gratuitas para converter, comprimir, redimensionar, cortar, editar e transformar suas imagens. Todo o processamento acontece no seu navegador — rápido, privado e seguro.',
  },
  tools: {
    compressImage: { title: 'Comprimir IMAGEM', desc: 'Comprima JPG, PNG, SVG e GIFs economizando espaço e mantendo a qualidade.' },
    resizeImage: { title: 'Redimensionar IMAGEM', desc: 'Defina suas dimensões por porcentagem ou pixel e redimensione suas imagens.' },
    cropImage: { title: 'Cortar IMAGEM', desc: 'Corte JPG, PNG ou GIFs com facilidade.' },
    convertToJpg: { title: 'Converter para JPG', desc: 'Converta imagens PNG, GIF, SVG, WEBP para JPG em lote.' },
    convertFromJpg: { title: 'Converter de JPG', desc: 'Converta imagens JPG para PNG e GIF.' },
    qrCodeGenerator: { title: 'Gerador de QR Code', desc: 'Gere QR codes personalizados para URLs, texto, WiFi e contatos.' },
    qrCodeScanner: { title: 'Leitor de QR Code', desc: 'Escaneie QR codes instantaneamente usando sua câmera ou enviando uma imagem.' },
    blurFace: { title: 'Desfocar Rosto', desc: 'Detecte e desfoque rostos automaticamente nas suas imagens para privacidade.' },
    removeBackground: { title: 'Remover Fundo', desc: 'Remova fundos de imagens rapidamente com alta precisão.' },
    watermarkImage: { title: 'Marca d\'Água', desc: 'Coloque uma imagem ou texto sobre suas imagens em segundos.' },
  },
  whyChoose: {
    label: 'Por que Nos Escolher',
    heading: 'A Maneira Mais Inteligente de Editar Imagens',
    subheading: 'Milhares de criadores, designers e desenvolvedores em todo o mundo confiam em nós.',
    reasons: {
      fast: { title: 'Rápido como um raio', desc: 'Todo processamento acontece direto no seu navegador. Sem upload para servidores externos.' },
      private: { title: '100% Privado e Seguro', desc: 'Seus arquivos nunca saem do seu dispositivo. Não armazenamos nem compartilhamos imagens.' },
      noLimits: { title: 'Sem Limites, Sem Cadastro', desc: 'Use todas as ferramentas quantas vezes quiser, totalmente grátis.' },
      quality: { title: 'Qualidade Profissional', desc: 'Nossos algoritmos entregam resultados de nível profissional.' },
      batch: { title: 'Processamento em Lote', desc: 'Converta, compacte e redimensione várias imagens de uma vez.' },
      everywhere: { title: 'Funciona em Todo Lugar', desc: 'Design responsivo para desktop, tablet e celular.' },
    },
    stats: {
      imagesProcessed: 'Imagens Processadas',
      countriesServed: 'Países Atendidos',
      uptime: 'Disponibilidade',
      freeTools: 'Ferramentas Gratuitas',
    },
  },
  footer: {
    tagline: 'Ferramentas online grátis de imagem — converta, comprima, redimensione, recorte e edite suas imagens em segundos. Sem cadastro.',
    imageTools: 'Ferramentas de Imagem',
    moreTools: 'Mais Ferramentas',
    company: 'Empresa',
    contact: 'Contato',
    allRightsReserved: 'Todos os direitos reservados.',
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
  },
  faq: {
    badge: 'FAQ',
    heading: 'Perguntas Frequentes',
    subheading: 'Respostas rápidas para perguntas comuns sobre esta ferramenta.',
    stillHaveQuestions: 'Ainda tem dúvidas? Estamos aqui para ajudar!',
    reachOut: 'Fale com Nossa Equipe',
    questionHeader: 'Pergunta',
  },

  contactForm: {
    badge: 'Entre em Contato',
    title: 'Fale Conosco',
    subtitle: 'Adoraríamos ouvir de você. Nos envie uma mensagem!',
    nameLabel: 'Nome',
    namePlaceholder: 'Seu nome completo',
    emailLabel: 'E-mail',
    emailPlaceholder: 'voce@email.com.br',
    subjectLabel: 'Assunto',
    subjectPlaceholder: 'Sobre o que se trata?',
    messageLabel: 'Mensagem',
    messagePlaceholder: 'Escreva sua mensagem aqui…',
    errName: 'O nome é obrigatório',
    errEmail: 'O e-mail é obrigatório',
    errEmailInvalid: 'Insira um e-mail válido',
    errSubject: 'O assunto é obrigatório',
    errMessage: 'A mensagem é obrigatória',
    sending: 'Enviando…',
    send: 'Enviar Mensagem',
    successTitle: 'Mensagem Enviada!',
    successMsg: 'Obrigado por entrar em contato. Responderemos em breve.',
    sendAnother: 'Enviar Outra',
    sendError: 'Algo deu errado. Por favor, tente novamente.',
  },

  about: {
    label: 'Sobre Nós', heading: 'Feito para Criadores, por Criadores', subheading: 'Acreditamos que ferramentas de imagem poderosas devem ser gratuitas, rápidas e acessíveis a todos.',
    missionTitle: 'Nossa Missão', missionText: 'photremium.com foi criado com um objetivo simples: oferecer a experiência de edição de imagens mais intuitiva, rápida e privada na web.',
    privacyTitle: 'Privacidade em Primeiro Lugar', privacyText: 'Nunca fazemos upload, armazenamos ou processamos suas imagens em servidores remotos.',
    techTitle: 'Tecnologia Moderna', techText: 'Construído com tecnologias web de ponta incluindo WebAssembly, Canvas API e React moderno.',
    communityTitle: 'Guiado pela Comunidade', communityText: 'Cada recurso que construímos é inspirado pelo feedback real dos usuários.',
    globalTitle: 'Alcance Global', globalText: 'Usado por criadores em mais de 120 países.',
  },
  seo: {
    homeTitle: 'photremium.com — Conversor, Compressor e Editor de Imagens Grátis', homeDesc: 'Converta, comprima, redimensione, corte e edite imagens online grátis.',
    homeKeywords: 'conversor de imagens, compressor de imagens, redimensionar imagem, editor de fotos',
    aboutTitle: 'Sobre photremium.com — Nossa Missão e História', aboutDesc: 'Conheça o photremium.com, o kit de ferramentas de imagem online gratuito.',
    aboutKeywords: 'sobre photremium.com, ferramentas de imagem, editor de imagem grátis',
  },

  privacyPolicyPage: {
    seo: {
      title: 'Política de Privacidade — Photremium | Sem upload para servidor, armazenamento zero',
      description: 'A Política de Privacidade da Photremium explica como protegemos sua privacidade. Todo processamento ocorre no seu navegador.',
      ogTitle: 'Política de Privacidade — Photremium | Sem upload, sem armazenamento',
      ogDescription: 'Seus arquivos ficam no seu dispositivo. O processamento é local no navegador.',
      twitterTitle: 'Política de Privacidade — Photremium',
      twitterDescription: 'Ferramentas 100% no navegador. Sem upload, sem armazenamento e sem rastreamento.',
      schemaName: 'Política de Privacidade - Photremium',
      schemaDescription: 'Política de Privacidade da Photremium: sem upload para servidor e sem armazenamento de dados.',
    },
    hero: {
      badge: 'Política de Privacidade',
      titlePrefix: 'Sua Privacidade É Nossa',
      titleHighlight: 'Prioridade Máxima',
      subPrefix: 'photremium.com foi criado com um princípio simples —',
      subStrong: 'seus arquivos nunca saem do seu dispositivo',
      subSuffix: 'Todas as ferramentas funcionam no seu navegador. Sem upload. Sem nuvem. Sem compromisso.',
      effectiveLabel: 'Vigência',
      lastUpdatedLabel: 'Última atualização',
      worldwideLabel: 'Aplicável no mundo todo',
    },
    trustCards: [
      { title: 'Sem Upload para Servidor', desc: 'Seus arquivos não saem do seu dispositivo. Processamento totalmente local.' },
      { title: 'Armazenamento Zero', desc: 'Não armazenamos nada sobre você, suas imagens ou atividade.' },
      { title: 'Sem Rastreamento', desc: 'Sem tracking comportamental, sem fingerprinting, sem perfilamento.' },
      { title: 'Compatível com GDPR', desc: 'Projetado para respeitar regulamentações globais de privacidade.' },
    ],
    contentsTitle: 'Conteúdo',
    toc: {
      overview: 'Visão geral',
      'no-upload': 'Sem processamento em servidor',
      'data-collect': 'Dados que coletamos',
      cookies: 'Cookies e armazenamento',
      'third-party': 'Serviços de terceiros',
      analytics: 'Analytics',
      children: 'Privacidade infantil',
      rights: 'Seus direitos',
      security: 'Segurança',
      changes: 'Mudanças na política',
      contact: 'Contato',
    },
    sections: {
      overview: {
        title: '1. Visão geral',
        subtitle: 'O que esta política cobre',
        p1Prefix: 'Esta Política de Privacidade explica como',
        p1Middle: '("nós", "nosso") processa - ou mais precisamente,',
        p1Italic: 'não processa',
        p1Suffix: 'seus dados pessoais quando você usa nossas ferramentas gratuitas de imagem em',
        p2: 'Ao contrário de aplicativos web tradicionais que enviam arquivos para servidores remotos, o photremium.com usa APIs modernas do navegador (Canvas API, WebAssembly, WebWorkers) para executar tudo localmente no seu dispositivo. Resultado: sem transmissão de dados, sem armazenamento, sem risco.',
        calloutLabel: 'Resumo simples:',
        calloutText: 'Não conseguimos ver suas imagens, não queremos vê-las e nossa tecnologia foi criada para garantir isso.',
      },
      noUpload: {
        title: '2. Sem processamento no servidor — nunca',
        subtitle: 'Como nossas ferramentas realmente funcionam',
        introPrefix: 'Cada ferramenta no photremium.com — conversor, compressor, redimensionar, remover fundo, desfocar rosto, marca d\'água, recortar e QR — processa seus arquivos',
        introStrong: '100% no seu navegador',
        introSuffix: 'com JavaScript client-side e WebAssembly.',
        points: [
          { label: 'Sem upload de arquivos.', text: 'Quando você seleciona um arquivo, ele é lido pela File API do navegador e processado em memória; nunca é enviado pela rede.' },
          { label: 'Nenhum servidor recebe sua imagem.', text: 'Nosso CDN entrega apenas HTML, CSS e JavaScript necessários para o app funcionar.' },
          { label: 'Sem armazenamento temporário.', text: 'Os resultados existem apenas na memória do navegador e são liberados ao sair da página.' },
          { label: 'Funciona offline.', text: 'Muitas ferramentas continuam funcionando sem internet após o carregamento inicial.' },
        ],
        callout: 'Você pode verificar: abra a aba Network nas ferramentas de desenvolvedor, selecione uma imagem e confirme que não há envio de dados do arquivo para servidores externos.',
      },
      dataCollect: {
        title: '3. Dados que coletamos (e não coletamos)',
        subtitle: 'Transparência total sobre práticas de dados',
        headers: { type: 'Tipo de dado', collected: 'Coletado?', whereWhy: 'Onde / por quê' },
        rows: [
          { type: 'Suas imagens / arquivos', badge: 'Nunca', variant: 'green', showX: true, whereWhy: 'Processados totalmente no navegador — nunca transmitidos' },
          { type: 'Nome / e-mail', badge: 'Nunca', variant: 'green', showX: true, whereWhy: 'Sem conta ou cadastro' },
          { type: 'Endereço IP', badge: 'Mínimo', variant: 'gray', showX: false, whereWhy: 'Logs web padrão <= 30 dias, sem vínculo de identidade' },
          { type: 'Navegador / sistema operacional', badge: 'Mínimo', variant: 'gray', showX: false, whereWhy: 'Enviado automaticamente pelo navegador; apenas compatibilidade' },
          { type: 'Páginas visitadas / cliques', badge: 'Agregado', variant: 'blue', showX: false, whereWhy: 'Apenas análises anônimas' },
          { type: 'Preferência de idioma', badge: 'Somente local', variant: 'blue', showX: false, whereWhy: 'Salvo em localStorage no seu dispositivo' },
          { type: 'Dados de pagamento', badge: 'Nunca', variant: 'green', showX: true, whereWhy: 'photremium.com é totalmente gratuito' },
        ],
      },
      cookies: {
        title: '4. Cookies e armazenamento local',
        subtitle: 'O que é armazenado no seu dispositivo',
        intro: 'O photremium.com não usa cookies de publicidade, rastreamento entre sites nem cookies de terceiros.',
        points: [
          { label: 'Preferência de idioma', text: 'Salva em localStorage para lembrar seu idioma entre visitas.' },
          { label: 'Preferências de tema / UI', text: 'Se você definir preferências visuais, elas ficam somente no seu dispositivo.' },
          { label: 'Sem cookies de sessão.', text: 'Não há sistema de login, então não existem cookies de sessão.' },
        ],
        callout: 'Você pode limpar o armazenamento local do photremium.com a qualquer momento nas configurações do navegador.',
      },
      thirdParty: {
        title: '5. Serviços de terceiros',
        subtitle: 'Quais serviços externos usamos e por quê',
        intro: 'O photremium.com usa um conjunto mínimo de serviços de terceiros confiáveis para infraestrutura e desempenho.',
        headers: { service: 'Serviço', purpose: 'Finalidade', dataShared: 'Dados compartilhados', privacyPolicy: 'Política de privacidade' },
        rows: [
          { service: 'Cloudflare Pages', purpose: 'Hospedagem e entrega via CDN', dataShared: 'Endereço IP, cabeçalhos HTTP (padrão)', privacyLink: 'https://www.cloudflare.com/privacypolicy/', privacyText: 'cloudflare.com/privacypolicy' },
          { service: 'Font Awesome', purpose: 'Ícones carregados via CDN', dataShared: 'Endereço IP (requisição CSS)', privacyLink: 'https://fontawesome.com/privacy', privacyText: 'fontawesome.com/privacy' },
          { service: 'Google Fonts', purpose: 'Carregamento de fontes', dataShared: 'Endereço IP (requisição de fonte)', privacyLink: 'https://policies.google.com/privacy', privacyText: 'policies.google.com' },
        ],
        outro: 'Não compartilhamos seus dados com anunciantes, corretores de dados ou outros terceiros.',
      },
      analytics: {
        title: '6. Análises',
        subtitle: 'Dados agregados que respeitam a privacidade',
        introPrefix: 'Para entender quais ferramentas são mais usadas e melhorar o site, podemos coletar estatísticas de uso',
        introStrong: 'agregadas e anonimizadas',
        introSuffix: 'como:',
        points: [
          'Número de visualizações por ferramenta (sem identificação do usuário)',
          'Origem de tráfego (pesquisa Google, link direto) — sem dados pessoais',
          'Geografia em nível de país',
          'Tipo de navegador / dispositivo para compatibilidade',
        ],
        calloutLabel: 'Nenhum dado é vinculado pessoalmente a você.',
        calloutText: 'Não usamos Google Analytics nem Meta Pixel.',
      },
      children: {
        title: '7. Privacidade infantil',
        subtitle: 'Conformidade com proteção de menores',
        p1: 'O photremium.com não coleta intencionalmente dados pessoais de crianças menores de 13 anos (ou 16 na UE conforme o GDPR).',
        p2Prefix: 'Se você acredita que uma criança enviou dados pessoais por meio do nosso formulário de contato, fale conosco imediatamente em',
        p2Suffix: 'e removeremos esses dados rapidamente.',
      },
      rights: {
        title: '8. Seus direitos',
        subtitle: 'Direitos globais de privacidade',
        intro: 'Como o photremium.com não coleta dados pessoalmente identificáveis, muitos direitos se aplicam de forma direta.',
        points: [
          { label: 'Direito de acesso', text: 'Você pode solicitar uma cópia dos dados que temos sobre você.' },
          { label: 'Direito de retificação', text: 'Você pode pedir correção de dados incorretos.' },
          { label: 'Direito de exclusão', text: 'Você pode solicitar a exclusão de dados pessoais (GDPR Art. 17, CCPA).' },
          { label: 'Direito de oposição / opt-out', text: 'Você pode desativar análises futuras por meio de ferramentas do navegador.' },
          { label: 'Direito à portabilidade', text: 'Seu trabalho é baixado diretamente para seu dispositivo.' },
        ],
        callout: 'Esses direitos se aplicam globalmente a todos os usuários.',
      },
      security: {
        title: '9. Segurança',
        subtitle: 'Como protegemos sua experiência',
        intro: 'Os dados mais seguros são aqueles que nunca são coletados.',
        points: [
          { label: 'HTTPS obrigatório', text: 'O tráfego entre seu navegador e nosso CDN é criptografado com TLS 1.2+ e HSTS.' },
          { label: 'Content Security Policy (CSP)', text: 'Cabeçalhos rígidos ajudam a impedir XSS e injeção de scripts.' },
          { label: 'Auditorias regulares de dependências', text: 'Auditamos e atualizamos pacotes npm regularmente.' },
        ],
        disclosurePrefix: 'Divulgação responsável',
        disclosureTextPrefix: 'Se você encontrar um problema de segurança, envie e-mail para',
        disclosureTextSuffix: 'e responderemos em até 48 horas.',
      },
      changes: {
        title: '10. Mudanças nesta política',
        subtitle: 'Como lidamos com atualizações',
        intro: 'Podemos atualizar esta política periodicamente para refletir mudanças legais ou técnicas.',
        points: [
          { label: '"Última atualização"', text: 'a data no topo desta página será revisada.' },
          { label: 'Mudanças significativas', text: 'serão anunciadas com aviso em destaque na página inicial por pelo menos 30 dias.' },
          { label: 'Versões anteriores', text: 'são arquivadas e podem ser disponibilizadas mediante solicitação.' },
        ],
        outro: 'O uso contínuo do photremium.com após a publicação das mudanças constitui aceitação da política atualizada.',
      },
      contact: {
        title: '11. Contato e solicitações de dados',
        subtitle: 'Fale conosco sobre privacidade',
        p1Prefix: 'Para perguntas, dúvidas ou solicitações formais de dados relacionadas a esta política, entre em contato conosco. Nosso objetivo é responder em até',
        p1Strong: '5 dias úteis',
      },
    },
    footer: {
      privacyQuestionsTitle: 'Dúvidas sobre privacidade?',
      privacyQuestionsDesc: 'Envie suas dúvidas ou solicitações de dados e responderemos rapidamente.',
      versionHistoryTitle: 'Histórico de versões',
      v2Label: 'v2.0 — Reescrita principal',
      v11Label: 'v1.1 — Direitos CCPA adicionados',
      v10Label: 'v1.0 — Política inicial',
    },
  },

  common: {
    new: 'Novo!', download: 'Baixar', downloadAll: 'Baixar Tudo', upload: 'Enviar', dragDrop: 'Arraste e solte imagens aqui, ou clique para procurar',
    remove: 'Remover', reset: 'Redefinir', apply: 'Aplicar', cancel: 'Cancelar', clear: 'Limpar', close: 'Fechar', save: 'Salvar', processing: 'Processando...',
    noFiles: 'Nenhum arquivo selecionado', selectFiles: 'Selecionar arquivos', or: 'ou', browseFiles: 'Procurar arquivos', dropHere: 'Solte os arquivos aqui',
    quality: 'Qualidade', width: 'Largura', height: 'Altura', format: 'Formato', compression: 'Compressão', preview: 'Pré-visualização',
    original: 'Original',
    result: 'Resultado',
    before: 'Antes',
    after: 'Depois',
    downloadAs: 'Baixar como:',
    zip: 'ZIP',
    separate: 'Separado',
    chooseFiles: 'Escolher arquivos',
    pasteHint: 'Você também pode colar imagens com',
    startOver: 'Começar de novo',
    startOverConfirm: 'Remover todas as imagens e começar de novo?',
    addMoreImages: 'Adicionar mais imagens',
    addImage: 'Adicionar imagem',
    images: 'Imagens',
    totalSize: 'Tamanho total',
    size: 'Tamanho',
    type: 'Tipo',
    unsavedEdits: 'Você tem edições não salvas. Sair da página?',
    compareSlider: 'Comparar controle deslizante',
    toggleToolsPanel: 'Alternar painel de ferramentas',
    closePanel: 'Fechar painel',
    zoomIn: 'Ampliar',
    zoomOut: 'Reduzir',
    fit: 'Ajustar',
    none: 'Nenhum',
  },

  compressor: {
    seo: {
      uploadTitle: 'Compressor de Imagens — Comprimir JPG, PNG, SVG, GIF Grátis | photremium.com',
      uploadDesc: 'Comprima imagens JPG, PNG, SVG e GIF online grátis. Reduza o tamanho do arquivo em até 80% mantendo a qualidade visual. Sem cadastro necessário.',
      uploadKeywords: 'compressor de imagens, comprimir jpg, comprimir png, reduzir tamanho imagem, otimização de imagens',
      workspaceTitle: 'Comprimindo Imagens — photremium.com Compressor de Imagens',
      workspaceDesc: 'Ajuste o nível de compressão e baixe imagens otimizadas. Pré-visualização em tempo real.',
      workspaceKeywords: 'comprimir imagens, compressão de imagens, otimizar imagens em lote',
    },
    title: 'Compressor de Imagens',
    desc: 'Comprima imagens JPG, PNG e GIF até 80% menores. Rápido e privado.',
    toCompress: 'para comprimir',
    compressionForAll: 'Compressão para todas as imagens',
    summary: 'Resumo',
    originalSize: 'Tamanho original',
    compressed: 'Comprimido',
    saved: 'Economizado',
    compressionLabel: 'Compressão:',
    compressing: 'Comprimindo…',
    compressDownload: 'Comprimir e Baixar',
    lowQualityWarning: 'Uma compressão alta pode reduzir bastante a nitidez da imagem.',
    blog: {
      tocTitle: 'Conteúdo',
      title: 'Blog do Compressor de Imagens',
      formatsIntro: 'Nossa ferramenta oferece suporte a todos os formatos de imagem. Assim, você pode comprimir qualquer imagem sem dificuldades. A lista de todos os formatos está abaixo:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. O que é um compressor de imagens?',
          paragraphs: [
            'Um compressor de imagens é uma ferramenta ou serviço online que reduz o tamanho do arquivo da imagem mantendo sua qualidade visual. Porém, comprimir em excesso pode reduzir a qualidade de forma perceptível.',
          ],
          listTitle: 'TIPOS:',
          bullets: [
            'Compressão com perda: nesse tipo, o tamanho da imagem é reduzido removendo parte dos dados. A qualidade pode cair, mas geralmente a diferença não é perceptível a olho nu.',
            'Compressão sem perda: reduz o tamanho do arquivo sem afetar a qualidade visual da imagem.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Por que escolher nossa ferramenta?',
          bullets: [
            'Nossa ferramenta de compressão com IA funciona perfeitamente em todos os dispositivos para entregar os melhores resultados possíveis.',
            'Você pode comprimir várias imagens (até 100+) de uma só vez com apenas um clique.',
            'Não é necessário enviar imagens para nossos servidores. Tudo é comprimido localmente no seu navegador.',
            'Nosso compressor de imagens é totalmente gratuito para sempre. Você também pode compartilhar esta ferramenta com seus amigos.',
            'Você pode escolher o percentual de compressão de acordo com sua preferência.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Guia passo a passo',
          steps: [
            {
              heading: '1. Selecione a(s) imagem(ns) que deseja comprimir.',
              bullets: [
                'Arraste e solte a(s) imagem(ns) na caixa de envio.',
                'Você também pode copiar e colar a(s) imagem(ns) na caixa com (Ctrl + V).',
                'O explorador de arquivos também é suportado ao clicar no botão de escolha.',
              ],
            },
            {
              heading: '2. Em seguida, selecione o percentual de compressão.',
              bullets: [
                'Um controle deslizante horizontal oferece uma experiência confortável para escolher a compressão. Siga estas faixas para obter resultados mais precisos.',
              ],
              table: {
                headers: ['Percentual de compressão', 'Resultados'],
                rows: [
                  ['1%  a  40%', 'Melhor qualidade'],
                  ['41%  a  60%', 'Qualidade normal (recomendado)'],
                  ['61%  a  100%', 'Qualidade ruim'],
                ],
              },
            },
            {
              heading: '3. Verifique o espaço economizado.',
              paragraphs: [
                'Todas as métricas de memória são exibidas em tempo real. Você pode ver claramente quanto economizou e ajustar o nível de compressão conforme sua necessidade.',
              ],
            },
            {
              heading: '4. Selecione a opção de download no botão de alternância.',
              bullets: [
                'ZIP: ao comprimir várias imagens, esta opção aparece. Selecionando ZIP, suas imagens comprimidas serão agrupadas em um arquivo zip (recomendado para muitas imagens).',
                'Separado: esta opção baixa todas as imagens separadamente, e não em um único ZIP (recomendado para poucas imagens, menos de 10).',
              ],
            },
            {
              heading: '5. Comprima e baixe a imagem.',
              paragraphs: [
                'Este botão baixa automaticamente todas as imagens comprimidas na opção de download selecionada.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Benefícios do compressor de imagens.',
          bullets: [
            'Reduz custos de armazenamento: ao comprimir imagens, o tamanho é reduzido e você precisa de menos espaço.',
            'Carregamento mais rápido: imagens comprimidas carregam mais rápido e melhoram a experiência do usuário.',
            'Solução para o limite do Gmail: como o Gmail limita anexos a 25MB, comprimir imagens ajuda a enviar mais arquivos.',
            'Compartilhamento e transferência mais rápidos: arquivos grandes demoram mais; a compressão economiza tempo e dados e ajuda em plataformas com limites.',
            'Otimização de apresentações: apresentações com imagens não comprimidas podem ficar pesadas e lentas; com imagens comprimidas, ficam mais leves e fáceis de enviar.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Formatos suportados.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Conversor de Imagens — Converter PNG, JPG, WEBP, GIF, SVG Grátis | photremium.com',
      uploadDesc: 'Converta imagens entre JPG, PNG, WEBP, GIF, SVG, TIFF, BMP e mais. Conversor de imagens online grátis — rápido, privado, sem cadastro necessário.',
      uploadKeywords: 'conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',
      workspaceKeywords: 'converter imagens, conversor de formato de imagem, converter imagens em lote',

      routeKeywords: {

        'png-to-jpg': 'png para converter jpg, png to jpg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'jpg-to-png': 'jpg para converter png, jpg to png, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'png-to-webp': 'png para converter webp, png to webp, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'jpg-to-webp': 'jpg para converter webp, jpg to webp, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'webp-to-jpg': 'webp para converter jpg, webp to jpg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'webp-to-png': 'webp para converter png, webp to png, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'gif-to-jpg': 'gif para converter jpg, gif to jpg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'gif-to-png': 'gif para converter png, gif to png, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'bmp-to-jpg': 'bmp para converter jpg, bmp to jpg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'bmp-to-png': 'bmp para converter png, bmp to png, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'svg-to-png': 'svg para converter png, svg to png, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'svg-to-jpg': 'svg para converter jpg, svg to jpg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'tiff-to-jpg': 'tiff para converter jpg, tiff to jpg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'tiff-to-png': 'tiff para converter png, tiff to png, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'jpg-to-gif': 'jpg para converter gif, jpg to gif, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'png-to-gif': 'png para converter gif, png to gif, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'jpg-to-bmp': 'jpg para converter bmp, jpg to bmp, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'png-to-bmp': 'png para converter bmp, png to bmp, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'webp-to-gif': 'webp para converter gif, webp to gif, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'jpg-to-ico': 'jpg para converter ico, jpg to ico, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'png-to-ico': 'png para converter ico, png to ico, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'jpg-to-svg': 'jpg para converter svg, jpg to svg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'png-to-svg': 'png para converter svg, png to svg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'webp-to-svg': 'webp para converter svg, webp to svg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'gif-to-svg': 'gif para converter svg, gif to svg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'bmp-to-svg': 'bmp para converter svg, bmp to svg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

        'tiff-to-svg': 'tiff para converter svg, tiff to svg, conversor de imagens, png para jpg, jpg para png, conversor webp, conversor de formato de imagem, conversor de imagens grátis',

      },
    },
    title: 'Conversor de Imagens',
    desc: 'Converta imagens entre JPG, PNG, WEBP, GIF, SVG, TIFF, BMP e mais.',
    toConvert: 'para converter',
    convertSettings: 'Configurações de conversão',
    detected: 'Detectado',
    convertTo: 'Converter para',
    converting: 'Convertendo…',
    convertToFormat: 'Converter para {format}',
    popularConversions: 'Conversões populares',
    convertingTo: 'Convertendo para',
    all: 'Todos',
  },

  resizer: {
    seo: {
      uploadTitle: 'Redimensionar Imagem Online — Redimensionar JPG, PNG, SVG, GIF Grátis | photremium.com',
      uploadDesc: 'Redimensione imagens online grátis por pixels ou porcentagem. Redimensione JPG, PNG, SVG e GIF preservando a qualidade. Sem cadastro necessário.',
      uploadKeywords: 'redimensionar imagem, redimensionador de imagens, redimensionar jpg, redimensionar png, mudar dimensões imagem, redimensionar foto online grátis',
      workspaceTitle: 'Redimensionando Imagens — photremium.com Redimensionador de Imagens',
      workspaceDesc: 'Redimensione imagens online grátis por pixels ou porcentagem. Sem cadastro necessário.',
      workspaceKeywords: 'redimensionar imagem, redimensionador de imagens, redimensionar jpg, redimensionar png',
    },
    title: 'Redimensionar Imagem',
    desc: 'Defina dimensões em pixels, porcentagem, centímetros ou polegadas e redimensione instantaneamente.',
    toResize: 'para redimensionar',
    resizeSettings: 'Configurações de redimensionamento',
    resizeBy: 'Redimensionar por:',
    byPixels: 'Por pixels',
    byPercentage: 'Por porcentagem',
    byCentimeters: 'Por centímetros',
    byInches: 'Por polegadas',
    advanced: 'Avançado',
    lockAspect: 'Bloquear proporção',
    unlockAspect: 'Desbloquear proporção',
    dontEnlarge: 'Não ampliar se o original for menor',
    resizing: 'Redimensionando…',
    resizeDownload: 'Redimensionar e Baixar',
    blog: {
      tocTitle: 'Conteúdo',
      title: 'Blog de Redimensionamento de Imagens',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Por que usar um redimensionador de imagens?',
          paragraphs: [
            'Um redimensionador de imagens é uma ferramenta/software usada para alterar as dimensões de uma imagem. Você pode ajustar altura, largura ou ambas para obter o tamanho necessário. Isso é especialmente útil para plataformas de redes sociais que possuem limites de tamanho para upload/publicação de imagens.',
          ],
          listTitle: 'Por exemplo:',
          bullets: [
            'Post do Instagram: 1080 x 1080px (quadrado)',
            'Post do Facebook: 1200 x 630px',
            'Post no X (Twitter): 1200 x 675px',
            'Story do Instagram: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Por que escolher nosso redimensionador de imagens?',
          paragraphs: [
            'Nosso redimensionador de imagens com IA permite ajustar imagens com precisão e muita rapidez. A ferramenta funciona sem travamentos em qualquer dispositivo e não exige instalação de app. Todos os recursos estão disponíveis online no navegador.',
          ],
          bullets: [
            'Você pode redimensionar várias imagens ao mesmo tempo (até 100+). Em dispositivos potentes, também é possível processar 400–500 imagens em segundos.',
            'Tudo é processado localmente no navegador. Não é necessário enviar imagens para nossos servidores, então suas imagens não saem do seu dispositivo.',
            'Suporte para múltiplas unidades de redimensionamento.',
            'Você pode manter a proporção da imagem com apenas uma caixa de seleção.',
            'Ao redimensionar várias imagens, você pode baixar separadamente ou em arquivo ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Guia passo a passo',
          steps: [
            {
              heading: 'Primeiro, selecione as imagens (uma ou várias) que você deseja redimensionar. Há várias formas de selecionar.',
              bullets: [
                'Arraste e solte imagens na área de envio.',
                'Você também pode colar imagens com o atalho “Ctrl + V”.',
                'Ou clique em “Choose Files” para selecionar no explorador de arquivos.',
              ],
            },
            {
              heading: 'Depois, selecione a unidade de redimensionamento. As unidades disponíveis são:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Em seguida, ajuste altura e largura para redimensionar. Você também pode manter a proporção marcando a opção.',
            },
            {
              heading: 'Se não quiser ampliar além do tamanho original, marque “Don’t enlarge if original is smaller”.',
            },
            {
              heading: 'Depois, escolha uma opção de download.',
              bullets: [
                'Selecione ZIP se quiser baixar todas as imagens redimensionadas em um único arquivo zip.',
                'Selecione “separate” se quiser baixar cada imagem separadamente.',
              ],
            },
            {
              heading: 'Por fim, clique em “Resize & Download” para baixar conforme a opção escolhida.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Benefícios da ferramenta de redimensionamento: o maior benefício é ajustar corretamente imagens para páginas web e posts em redes sociais.',
          tocLabel: '4. Benefícios da ferramenta de redimensionamento',
          bullets: [
            'Melhora da UX: tamanho e posicionamento corretos das imagens melhoram bastante a experiência do usuário.',
            'Compatível com redes sociais: muitas plataformas têm limites de dimensão, e a ferramenta ajuda a atender esses padrões.',
            'Design responsivo: desenvolvedores precisam de vários tamanhos para diferentes dispositivos.',
            'Melhor opção: em vez de esticar ou cortar agressivamente a imagem, redimensionar costuma preservar melhor o resultado.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Formatos suportados: nosso redimensionador permite selecionar imagens de qualquer formato. Formatos suportados:',
          tocLabel: '5. Formatos suportados',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Cortar Imagem Online — Cortar JPG, PNG, GIF Grátis | photremium.com',
      uploadDesc: 'Corte imagens JPG, PNG e GIF online com facilidade. Escolha pixels para definir a área de corte ou use nosso editor visual. Grátis, rápido e privado.',
      uploadKeywords: 'cortar imagem, ferramenta de corte, recortar jpg, recortar png, recortar foto online grátis, ferramenta de corte de imagem',
      workspaceTitle: 'Cortando Imagens — photremium.com Ferramenta de Corte',
      workspaceDesc: 'Corte imagens online grátis. Editor visual com proporções predefinidas. Sem cadastro necessário.',
      workspaceKeywords: 'cortar imagem, ferramenta de corte, recortar jpg, recortar png',
    },
    title: 'Recortar Imagem',
    desc: 'Recorte imagens JPG, PNG, GIF e mais com o editor visual.',
    toCrop: 'para recortar',
    cropSettings: 'Configurações de recorte',
    widthPx: 'Largura (px)',
    heightPx: 'Altura (px)',
    positionX: 'Posição X (px)',
    positionY: 'Posição Y (px)',
    cropTemplate: 'Modelo de recorte',
    landscape: 'Paisagem',
    portrait: 'Retrato',
    square: 'Quadrado',
    freeform: 'Livre',
    cropping: 'Recortando…',
    cropDownload: 'Recortar e Baixar',
    cropDownloadAll: 'Recortar tudo e baixar',
    saveNext: 'Salvar e Próximo',
    croppedNofTotal: 'Você recortou {n} de {total} imagens.',
    downloadN: 'Baixar {n}',
    blog: {
      tocTitle: 'Conteúdo',
      title: 'Blog do Recortador de Imagens',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Por que usar um recortador de imagens?',
          paragraphs: [
            'O recortador de imagens é uma ferramenta de software usada para cortar a imagem no formato desejado. Ele é amplamente utilizado para cortar uma parte necessária da imagem e remover a parte externa indesejada para qualquer finalidade. Ele fornece uma caixa de recorte que você pode ajustar na posição em que deseja recortar.',
          ],
          listTitle: 'Por exemplo:',
          bullets: [
            'Recortar sua própria imagem de uma foto em grupo.',
            'Recortar seu nome de uma lista.',
            'Recortar a barra de progresso de uma captura de tela completa.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Por que escolher o nosso recortador de imagens?',
          paragraphs: [
            'Nossa ferramenta de recorte de imagens permite que você recorte imagens com precisão e muito rápido. Você só precisa ajustar o tamanho da caixa de recorte na posição que deseja cortar em qualquer imagem. Quase todos os formatos de imagem são suportados para seleção da imagem.',
          ],
          bullets: [
            'Você pode recortar quantas imagens seu dispositivo suportar. Se você tiver um dispositivo de alto desempenho, pode recortar até mais de 100 imagens de uma vez sem travamentos ou outros problemas.',
            'Suas imagens serão processadas no seu navegador local. Não é necessário enviar nenhuma imagem para nossos servidores, então nenhuma imagem sai do seu dispositivo. Você pode recortar suas imagens pessoais sem insegurança ou risco.',
            'Muitas ferramentas sinalizam erro de formato de imagem inválido. Nossa ferramenta de recorte de imagens cuida desse problema ao oferecer suporte a quase todos os formatos de imagem.',
            'Se você estiver recortando várias imagens de uma vez, nossa ferramenta permite baixar as imagens recortadas como ZIP ou como imagens separadas de acordo com sua preferência.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Guia passo a passo',
          steps: [
            {
              heading: '1. Antes de tudo, selecione a imagem que você deseja recortar. Selecionar várias imagens de uma vez também é suportado pela nossa ferramenta de recorte de imagens.',
              bullets: [
                'Arraste e solte a imagem na caixa para recortá-la.',
                'Você também pode selecionar a imagem pelo explorador de arquivos clicando no botão escolher arquivos colocado na caixa de recorte.',
                'O atalho Ctrl + V também é suportado para colar as imagens na caixa.',
              ],
            },
            {
              heading: '2. Em seguida, ajuste o tamanho e a posição da caixa de recorte na imagem para cortá-la.',
            },
            {
              heading: '3. Você também pode ajustar a caixa de recorte inserindo manualmente os valores de altura, largura, posição horizontal e posição vertical.',
            },
            {
              heading: '4. Você também pode usar alguns modelos prontos:',
              bullets: [
                'Paisagem(16:9)',
                'Retrato(9:16)',
                'Quadrado(1:1)',
              ],
            },
            {
              heading: '5. Em seguida, você deve selecionar uma das opções de download.',
              bullets: [
                'ZIP: Selecione esta opção se estiver recortando várias imagens e quiser baixar todas as imagens recortadas como um único arquivo.',
                'Separado: Se você quiser baixar todas as imagens recortadas separadamente, selecione esta opção no botão de alternância.',
              ],
            },
            {
              heading: '6. Em seguida, clique no botão Recortar e Baixar para baixar todas as suas imagens recortadas de acordo com suas dimensões predefinidas.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Benefícios do Recortador de Imagens: A ferramenta de recorte de imagens oferece vários benefícios no mundo digital. Alguns são descritos abaixo:',
          tocLabel: '4. Benefícios do Recortador de Imagens',
          bullets: [
            'Ajuste de imagens em molduras: O recortador de imagens ajuda você a ajustar as imagens corretamente em molduras. Essas molduras podem estar em uma página da web ou em qualquer plataforma de mídia social.',
            'Melhoria de UX: Como o posicionamento correto das imagens melhora a experiência do usuário, o recortador de imagens ajuda a melhorar a UX em grande medida.',
            'Remoção de borda indesejada: Você pode remover quaisquer bordas indesejadas de uma imagem para refiná-la.',
            'Separação do objeto desejado: Você também pode separar sua imagem de uma foto em grupo.',
            'Economia de armazenamento: Recortar a imagem definitivamente economiza armazenamento, pois a área bruta da imagem é cortada e apenas a parte desejada é salva.',
            'Otimização de apresentação: Como uma apresentação normal com 10 imagens não recortadas ocupa quase 30MB de armazenamento, a mesma apresentação com imagens recortadas pode ocupar quase 10MB de armazenamento.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Formatos suportados:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Editor de Fotos Online — Editar Imagens Grátis com Texto, Efeitos e Molduras | photremium.com',
      desc: 'Edite fotos online grátis — adicione texto, efeitos, molduras, adesivos e muito mais. Ferramentas simples mas poderosas de edição de imagens no seu navegador.',
      keywords: 'editor de fotos, editor de fotos online, editar foto online grátis, adicionar texto à imagem, efeitos de imagem, molduras de fotos',
    },
    title: 'Editor de Fotos',
    desc: 'Adicione texto, efeitos, molduras e adesivos às imagens.',
    toEdit: 'para editar',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Remover Fundo de Imagem Online Grátis | photremium.com',
      uploadDesc: 'Remova fundos de imagens com alta precisão rapidamente. Removedor de fundo online gratuito — funciona inteiramente no seu navegador.',
      uploadKeywords: 'remover fundo, removedor de fundo, remover fundo de imagem, fundo transparente, remover fundo grátis',
      workspaceTitle: 'Removendo Fundos — photremium.com Removedor de Fundo',
      workspaceDesc: 'Remova fundos de imagens online grátis. Sem cadastro necessário.',
      workspaceKeywords: 'remover fundo, removedor de fundo, fundo transparente',
    },
    title: 'Remover Fundo',
    desc: 'Remova fundos de imagens instantaneamente. 100% gratuito, funciona no seu navegador.',
    toRemoveBg: 'Remover fundo',
    backgroundRemover: 'Removedor de fundo',
    processingProgress: 'Progresso do processamento',
    processingNImages: 'Processando {n} imagem(ns)…',
    allNProcessed: 'Todas as {n} imagem(ns) processadas!',
    nOfTotalDone: '{n} / {total} concluído',
    fileName: 'Nome do arquivo',
    dimensions: 'Dimensões',
    status: 'Status',
    statusDone: '✓ Concluído',
    statusProcessing: '⏳ Processando',
    statusError: '✗ Erro',
    statusPending: '⏸ Pendente',
    badgeDone: 'Concluído',
    badgeProcessing: 'Processando…',
    badgeError: 'Erro',
    removingBg: 'Removendo fundo…',
    retry: 'Tentar novamente',
    downloading: 'Baixando…',
    nextImage: 'Próxima imagem',
  },

  watermark: {
    seo: {
      uploadTitle: 'Marca d\'Água em Imagens — Adicionar Marcas d\'Água de Texto e Logotipo Grátis | photremium.com',
      uploadDesc: 'Adicione marcas d\'água de texto ou imagem às suas fotos em segundos. Grátis, rápido e privado.',
      uploadKeywords: 'marca d\'água, adicionar marca d\'água, marca d\'água de texto, marca d\'água de logo, ferramenta de marca d\'água grátis',
      workspaceTitle: 'Adicionando Marca d\'Água — photremium.com Ferramenta de Marca d\'Água',
      workspaceDesc: 'Adicione marcas d\'água em imagens online grátis. Sem cadastro necessário.',
      workspaceKeywords: 'marca d\'água, adicionar marca d\'água, marca d\'água de texto, marca d\'água de logo',
    },
    title: 'Marca d\'água',
    desc: 'Adicione marcas d\'água de texto ou logotipo às imagens.',
    toWatermark: 'para marca d\'água',
    watermarkTools: 'Ferramentas de marca d\'água',
    addText: 'Adicionar texto',
    addImage: 'Adicionar imagem',
    layersN: 'Camadas ({n})',
    noLayers: 'Nenhuma camada adicionada ainda',
    textLayer: 'Camada de texto',
    imageLayer: 'Camada de imagem',
    watermarkDownloadAll: 'Marca d\'água e Baixar tudo',
    watermarkDownload: 'Marca d\'água e Baixar',
    nextImage: 'Próxima imagem',
    selectToEdit: 'Selecione qualquer imagem ou texto para começar a editar',
    bold: 'Negrito',
    italic: 'Itálico',
    underline: 'Sublinhado',
    opacity: 'Opacidade',
    delete: 'Excluir',
    duplicate: 'Duplicar',
    clearBackground: 'Limpar fundo',
    typeHere: 'Digite aqui...',
    linkCorners: 'Vincular cantos',
    separateCorners: 'Separar cantos',
    blog: {
      tocTitle: 'Conteúdo',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Visão geral da ferramenta de marca d\'água',
          title: 'Como adicionar marca d\'água às suas imagens online — o guia completo da ferramenta de marca d\'água da Photremium',
          paragraphs: [
            'Você acabou de terminar de editar uma bela fotografia. Pode ser uma foto de produto para sua loja, um retrato de uma sessão de cliente ou uma peça de arte digital que você passou horas aperfeiçoando. E agora vem a pergunta que todo criador acaba enfrentando: como proteger isso antes de compartilhar?',
            'A resposta a que a maioria dos profissionais chega é a marca d\'água — e com bons motivos. Uma marca d\'água posicionada corretamente atua como uma assinatura permanente do seu trabalho, tornando-o rastreável, com a sua marca e muito mais difícil de roubar.',
            'O problema que a maioria das pessoas enfrenta é o seguinte: as ferramentas disponíveis online são ou muito complicadas, ou travadas atrás de assinaturas, ou produzem uma marca d\'água tão pesada que estragam a imagem por completo.',
            'A ferramenta Watermark Image da Photremium foi criada para resolver tudo isso. É um espaço de trabalho de marca d\'água totalmente baseado no navegador, gratuito e sem necessidade de conta, que roda diretamente no seu navegador sem nunca enviar seus arquivos para um servidor. Tudo permanece local, tudo permanece rápido, e o nível de controle criativo que ela oferece rivaliza com o que você esperaria de um aplicativo de desktop. Neste guia, vamos mostrar exatamente como ela funciona, para quem foi criada e como obter os melhores resultados possíveis — sempre.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'O que é uma marca d\'água',
          title: 'O que é uma marca d\'água e por que isso importa?',
          paragraphs: [
            'Antes de mergulhar na ferramenta em si, vale entender o que uma marca d\'água faz e por que tantos fotógrafos, designers e criadores de conteúdo a consideram indispensável.',
            'Uma marca d\'água é uma sobreposição visível adicionada a uma imagem — normalmente texto, um logotipo ou um símbolo de copyright — que identifica o criador ou proprietário do conteúdo. Diferente dos metadados (que ficam escondidos dentro do arquivo e podem ser removidos em segundos), a marca d\'água fica incorporada visualmente na própria imagem. Você não pode simplesmente clicar com o botão direito e removê-la sem degradar visivelmente a qualidade da imagem.',
          ],
          subSections: [
            {
              title: 'Por que criadores usam marcas d\'água',
              paragraphs: [
                'Os motivos práticos para marcar suas imagens se resumem a três preocupações centrais.',
              ],
              bullets: [
                'Identificação de propriedade. Quando seu trabalho é compartilhado em redes sociais, painéis do Pinterest ou incorporado em posts de blog, a atribuição original muitas vezes se perde. A marca d\'água garante que seu nome ou sua marca acompanhem a imagem onde quer que ela vá.',
                'Dissuasão contra roubo. A maioria dos ladrões casuais de imagens procura o caminho de menor resistência. Uma marca d\'água com aparência profissional, especialmente bem posicionada e levemente transparente, envia um sinal claro: esta imagem pertence a alguém que se importa com seu trabalho.',
                'Proteção do portfólio do cliente. Fotógrafos que compartilham prévias com clientes antes do pagamento final frequentemente usam marcas d\'água para impedir que o cliente use a prévia sem quitar a fatura. Uma marca d\'água sutil faz isso sem tornar a prévia distraente demais para avaliação.',
              ],
            },
            {
              title: 'Quem deve marcar suas imagens',
              paragraphs: [
                'Se você se encaixa em qualquer uma das categorias a seguir, marcar suas imagens antes de compartilhar online não é opcional — é essencial:',
              ],
              bullets: [
                'Fotógrafos freelancers que compartilham galerias com clientes',
                'Designers gráficos que distribuem amostras de portfólio',
                'Vendedores de e-commerce que mostram fotos de produtos antes de acordos de licenciamento',
                'Artistas digitais que compartilham trabalhos em plataformas sociais',
                'Blogueiros e criadores de conteúdo cujas imagens são regularmente reutilizadas',
                'Contribuidores de fotos de banco de imagens construindo uma marca reconhecível',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Painéis do espaço de trabalho',
          title: 'Por dentro da ferramenta de marca d\'água da Photremium: um espaço de trabalho de três painéis criado para fluxos reais',
          paragraphs: [
            'O que faz a ferramenta de marca d\'água da Photremium se destacar dos marcadores de imagem online básicos é o design do espaço de trabalho. Em vez de oferecer uma abordagem simples de “digite o texto, escolha a posição, pronto”, a ferramenta fornece um layout de três painéis que espelha o que você encontraria em um software de design profissional — só que funciona totalmente no navegador, sem necessidade de instalação.',
          ],
          subSections: [
            {
              title: 'O painel esquerdo do canvas',
              paragraphs: [
                'O painel do canvas ocupa a maior parte da tela e mostra exatamente como sua imagem fica com a marca d\'água aplicada em tempo real. Cada alteração que você faz — ajustar a opacidade, reposicionar uma camada de texto, redimensionar um logotipo — aparece instantaneamente no canvas. Não existe botão de “preview” para clicar. O que você vê é o que você obtém.',
                'O canvas também inclui uma barra de zoom integrada, permitindo ampliar para um alinhamento preciso e reduzir para ver o quadro geral. O recurso de ajustar à tela calcula automaticamente a melhor escala inicial com base no tamanho da sua tela, então até imagens em alta resolução abrem em um tamanho confortável de trabalho. Guias de alinhamento aparecem dinamicamente quando você arrasta uma camada perto do centro horizontal ou vertical da imagem, encaixando a marca d\'água em uma posição perfeitamente centralizada com uma precisão que normalmente você só esperaria do Photoshop.',
              ],
            },
            {
              title: 'O painel de configurações à direita',
              paragraphs: [
                'O painel da direita é o centro de controle. É ali que você gerencia suas camadas de marca d\'água, personaliza sua aparência e dispara a exportação final. No desktop, ele fica fixo no lado direito da tela. Em dispositivos móveis, ele sobe como uma folha inferior — acionada por um botão de engrenagem flutuante — para nunca cobrir seu canvas enquanto você trabalha.',
                'Dentro do painel direito você encontra o gerenciador de camadas, que lista cada elemento de marca d\'água adicionado. Cada item mostra o tipo de camada (texto ou imagem), seu nome ou conteúdo atual e três botões de ação rápida: um alternador de visibilidade (ícone de olho), um alternador de bloqueio para congelar a posição da camada enquanto você trabalha nas outras, e um botão de exclusão.',
              ],
            },
            {
              title: 'A faixa de pré-visualização à esquerda (modo com várias imagens)',
              paragraphs: [
                'Quando você trabalha com várias imagens ao mesmo tempo — um lote de fotos de produto, uma sessão de retratos inteira — uma faixa vertical de miniaturas aparece na extremidade esquerda da tela. Essa é a fila de imagens, mostrando prévias reduzidas de cada arquivo carregado. Clicar em qualquer miniatura troca seu canvas para essa imagem instantaneamente, permitindo verificar como a marca d\'água fica em diferentes composições sem perder suas configurações de camada.',
                'A faixa também mostra o tamanho de cada arquivo em KB ou MB, junto com a etiqueta do formato (JPG, PNG, WEBP), para que você sempre saiba com o que está trabalhando de relance.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Passo a passo',
          title: 'Passo a passo: como adicionar uma marca d\'água à sua imagem no Photremium',
          paragraphs: [
            'Este guia se baseia diretamente em como a ferramenta funciona por baixo dos panos — desde o sistema de upload por arrastar e soltar até o mecanismo de renderização do canvas que escreve sua marca d\'água permanentemente na imagem antes do download.',
          ],
          steps: [
            {
              heading: 'Passo 1 — faça upload da sua imagem/imagens',
              paragraphsBefore: [
                'Acesse photremium.com/watermark-image. Você chegará à tela de upload, que apresenta uma área de arrastar e soltar limpa no centro da página.',
                'Você tem três maneiras de levar sua imagem para a ferramenta:',
              ],
              bullets: [
                'Arraste e solte. Arraste um ou mais arquivos de imagem da sua área de trabalho diretamente para a zona de soltura. A ferramenta aceita qualquer formato padrão de imagem — JPEG, PNG, WEBP e mais. Quando você arrasta arquivos sobre o espaço de trabalho, uma borda roxa é ativada ao redor de toda a área com o aviso visual “Drop images to add for watermarking”, para que você saiba que a ação de soltar foi registrada.',
                'Clique para procurar. Clique no botão “Choose Files” dentro da zona de soltura para abrir o seletor de arquivos do sistema. Você pode selecionar vários arquivos de uma vez usando Ctrl+Click (Windows) ou Cmd+Click (Mac).',
                'Cole da área de transferência. Se você copiou uma imagem para a área de transferência — de uma captura de tela, outro aplicativo ou um navegador — basta pressionar Ctrl+V (ou Cmd+V no Mac) na página da marca d\'água e a imagem será carregada diretamente no espaço de trabalho. Isso funciona mesmo quando várias imagens já estão carregadas.',
              ],
              paragraphsAfter: [
                'Assim que a primeira imagem carrega, o espaço de trabalho sai da tela de upload e entra no editor completo de três painéis, e o canvas exibe sua imagem em um nível de zoom ajustado automaticamente para caber na tela.',
              ],
            },
            {
              heading: 'Passo 2 — adicione uma camada de marca d\'água de texto',
              paragraphsBefore: [
                'Clique no botão roxo “Add Text” no painel direito. Uma nova camada de texto aparece no canvas com o texto de espaço reservado padrão “Type here...” já selecionado.',
                'Você pode começar a digitar imediatamente. O texto é renderizado ao vivo no canvas em Arial branco, com um tamanho padrão ajustado às dimensões da sua imagem. Na barra superior que aparece quando a camada de texto está selecionada, você pode personalizar todos os aspectos do texto:',
              ],
              bullets: [
                'Família da fonte — escolha entre 12 fontes integradas, incluindo Arial, Georgia, Impact, Brush Script MT, Comic Sans MS e mais',
                'Tamanho da fonte — digite um valor em pixels diretamente ou use os controles de incremento',
                'Negrito, itálico, sublinhado — ative qualquer combinação desses estilos',
                'Cor do texto — clique na amostra de cor para abrir o seletor e escolher qualquer cor hex',
                'Cor de fundo — adicione um fundo colorido atrás do texto para um visual de rótulo ou selo',
                'Contorno (stroke) — defina largura e cor do contorno para máxima legibilidade em imagens claras e escuras',
                'Opacidade — ajuste de 0% (invisível) a 100% (totalmente opaco); a maioria das marcas d\'água fica entre 30% e 60%',
                'Alinhamento — alinhe o texto à esquerda, ao centro ou à direita dentro da caixa delimitadora',
                'Rotação — gire a camada de texto para qualquer ângulo, com pontos magnéticos em 0°, 90°, 180° e 270° para posicionamento rápido em ângulos retos',
              ],
              paragraphsAfter: [
                'Para mover o texto, clique e arraste para qualquer lugar no canvas. Para posicionamento fino e preciso, use as setas do teclado (segure Shift para passos de 10 pixels). Para redimensionar a caixa de texto, arraste qualquer uma das oito alças de redimensionamento (cantos e bordas) que aparecem ao redor da camada selecionada.',
              ],
            },
            {
              heading: 'Passo 3 — adicione uma camada de marca d\'água de imagem (logotipo)',
              paragraphsBefore: [
                'Se quiser usar um logotipo, assinatura ou qualquer imagem como marca d\'água em vez de — ou além de — texto, clique no botão azul “Add Image” no painel direito. O seletor de arquivos será aberto para que você escolha o arquivo de imagem da marca d\'água no seu dispositivo.',
                'A ferramenta redimensiona automaticamente a imagem da marca d\'água para cerca de 30% da largura do canvas, mantendo a proporção original, e a centraliza no canvas. A partir daí, você pode arrastá-la para qualquer posição, redimensioná-la usando as alças de canto (que preservam a proporção) ou rotacioná-la usando a alça dedicada que aparece acima da camada selecionada.',
                'Para camadas de marca d\'água do tipo imagem, o painel direito expõe controles adicionais:',
              ],
              bullets: [
                'Opacidade — igual às camadas de texto, ideal para logos PNG transparentes',
                'Virar horizontal / Virar vertical — espelhe a marca d\'água se necessário',
                'Largura da borda, cor da borda e estilo da borda — adicione uma borda visível ao redor do logotipo da marca d\'água',
                'Raio da borda — arredonde os cantos do logo, de forma uniforme ou com controle separado para cada canto',
                'Rotação — o mesmo comportamento suave de rotação das camadas de texto',
              ],
            },
            {
              heading: 'Passo 4 — configure o tiling (opcional)',
              paragraphsBefore: [
                'Um dos recursos mais poderosos da ferramenta é o tiling — a capacidade de repetir sua marca d\'água em toda a imagem em um padrão de grade. Isso é especialmente útil quando você quer tornar uma imagem inutilizável para republicação, em vez de apenas marcada com a sua marca.',
                'Com uma camada selecionada, procure a opção tile na barra de ferramentas. Você pode defini-la para:',
              ],
              bullets: [
                'Nenhum — posicionamento único (padrão)',
                'Grade 2×2 — repete a marca d\'água em um padrão de 2 colunas por 2 linhas',
                'Grade 3×3 — repete em uma grade 3×3 para cobertura mais densa',
              ],
              paragraphsAfter: [
                'Você também pode ajustar o espaçamento dos tiles, que controla a distância entre cada repetição. O canvas mostra prévias fantasmas de todas as cópias em tile, para que você veja o padrão completo de cobertura antes de baixar.',
              ],
            },
            {
              heading: 'Passo 5 — use o gerenciador de camadas para várias marcas d\'água',
              paragraphsBefore: [
                'Você pode adicionar quantas camadas quiser — misturando livremente marcas d\'água de texto e imagem. O gerenciador de camadas no painel direito lista todas elas. Você pode:',
              ],
              bullets: [
                'Mostrar/ocultar camadas individuais usando o ícone de olho — útil para alternar entre diferentes versões da marca d\'água sem apagar nada',
                'Bloquear uma camada para evitar reposicionamento acidental enquanto trabalha em outras',
                'Excluir uma camada permanentemente',
              ],
              paragraphsAfter: [
                'Clicar em qualquer item da lista também o seleciona no canvas, facilitando alternar entre camadas sem ficar procurando pela imagem.',
              ],
            },
            {
              heading: 'Passo 6 — alterne entre várias imagens',
              paragraphsBefore: [
                'Se você enviou mais de uma imagem, use a faixa de miniaturas à esquerda para alternar a imagem ativa do canvas. As camadas de marca d\'água que você configurou se aplicam universalmente — elas serão renderizadas em todas as imagens do seu lote no momento da exportação.',
                'A ferramenta também faz uma verificação de consistência de resolução em todo o lote. Se suas imagens tiverem dimensões muito diferentes (mais de 5% de diferença em largura ou altura), um aviso aparecerá informando que a posição da marca d\'água pode parecer diferente entre as imagens devido à variação de tamanho. O mecanismo lida com isso de forma elegante por meio de um algoritmo de reposicionamento proporcional: ele calcula a posição da marca d\'água como uma porcentagem das dimensões da imagem de referência e aplica o mesmo posicionamento proporcional a cada outra imagem do lote, preservando a intenção visual mesmo em resoluções diferentes.',
              ],
            },
            {
              heading: 'Passo 7 — defina suas preferências de download',
              paragraphsBefore: [
                'Para trabalhos com uma única imagem, clique no botão “Download” abaixo do canvas para salvar a imagem com marca d\'água diretamente. O nome do arquivo será definido automaticamente como o nome original com “-watermarked” acrescentado antes da extensão. Imagens JPEG são exportadas com qualidade 0.95 — alta o suficiente para serem indistinguíveis do original em tamanhos normais de visualização. Imagens PNG são exportadas como PNG sem perdas.',
                'Para trabalhos em lote (várias imagens), você tem dois modos de download selecionáveis no painel direito:',
              ],
              bullets: [
                'Arquivo ZIP — todas as imagens com marca d\'água são empacotadas em um único arquivo ZIP baixado com um clique. A ferramenta carrega JSZip dinamicamente para lidar com a compressão.',
                'Arquivos separados — cada imagem é baixada como um arquivo individual com um pequeno intervalo entre os downloads para evitar limitação do navegador.',
              ],
            },
            {
              heading: 'Passo 8 — baixe e verifique',
              paragraphsBefore: [
                'Depois de clicar no botão de download (ou no botão “Watermark & Download All” para lotes), a ferramenta renderiza cada imagem em um elemento HTML5 canvas oculto na resolução nativa total — não no tamanho de prévia reduzido que você vê na tela. Isso significa que a imagem exportada está com 100% das dimensões originais em pixels, com a marca d\'água desenhada no tamanho proporcionalmente correto. Abra o arquivo baixado e amplie para verificar se o posicionamento e a qualidade da marca d\'água atendem às suas expectativas.',
                'Se algo parecer estranho, basta voltar ao espaço de trabalho — suas camadas ainda estarão lá — ajustar e baixar novamente.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Dicas profissionais',
          title: 'Dicas profissionais para obter os melhores resultados',
          bullets: [
            'Use um logo PNG semitransparente para um visual mais profissional. Uma marca d\'água com fundo transparente e opacidade entre 40% e 50% parece muito mais refinada do que texto sólido. Exporte seu logotipo da sua ferramenta de design como PNG com transparência alfa antes de usá-lo como camada de imagem.',
            'Posicione sua marca d\'água onde o corte dela retire valor. O canto inferior direito é o posicionamento mais comum — e o mais fácil de remover por corte. Para uma proteção mais forte, considere colocar a marca d\'água em uma área visualmente importante da imagem, como o rosto, um detalhe do produto ou o ponto focal. A opção de tile diagonal é ainda mais difícil de remover sem degradar significativamente a imagem.',
            'Use o recurso de bloqueio ao trabalhar com várias camadas. Assim que estiver satisfeito com a posição principal da sua marca d\'água, bloqueie essa camada antes de adicionar camadas secundárias. Isso evita mexer nela sem querer enquanto trabalha em outros elementos.',
            'Teste em áreas claras e escuras da imagem. Uma marca d\'água branca some em um céu claro, mas fica perfeitamente legível em uma sombra escura. Adicione um contorno sutil ou uma cor de fundo para garantir legibilidade independentemente do que estiver por baixo.',
            'Os atalhos de teclado sempre economizam tempo. As setas movem a camada selecionada um pixel por vez. Shift+seta move dez pixels por vez. A tecla Delete remove instantaneamente a camada selecionada. Esses atalhos tornam o ajuste fino muito mais rápido do que arrastar.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Privacidade e segurança',
          title: 'Privacidade e segurança: por que o processamento no navegador importa',
          paragraphs: [
            'Uma preocupação comum de muitos criadores ao usar ferramentas online é para onde suas imagens realmente vão. Em ferramentas de marca d\'água baseadas em servidor, sua imagem é enviada ao servidor do provedor, processada lá e depois devolvida a você. Isso significa que seu trabalho ainda não publicado, fotos de clientes ou imagens sensíveis de produtos passam pela infraestrutura de outra pessoa.',
            'A ferramenta de marca d\'água da Photremium processa tudo localmente no seu navegador. Suas imagens são carregadas na memória do seu dispositivo usando a File API do navegador e nunca são transmitidas pela internet. A renderização da marca d\'água acontece em um elemento HTML5 canvas executando em JavaScript, inteiramente dentro da aba do seu navegador. Quando você fecha a página ou clica em “Start Over”, todos os dados da imagem são liberados da memória e descartados. Nada é armazenado fora do seu próprio dispositivo.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Resumo final',
          title: 'Por que a ferramenta de marca d\'água da Photremium merece um lugar no seu fluxo de trabalho regular',
          paragraphs: [
            'Existem dezenas de ferramentas de marca d\'água disponíveis online. O que separa uma ferramenta que vale a pena salvar nos favoritos de outra que vale esquecer é geralmente uma combinação de velocidade, controle e confiabilidade.',
            'Velocidade importa porque marcar imagens com água não deve adicionar tempo significativo ao seu fluxo de pós-processamento. A ferramenta da Photremium carrega instantaneamente, processa localmente e exporta em resolução total em segundos — mesmo para lotes grandes. Não há espera por processamento no servidor, não há fila e não há tempo de renderização que aumente conforme mais usuários ficam online ao mesmo tempo.',
            'Controle importa porque uma marca d\'água com aparência errada é pior do que nenhuma marca d\'água — isso faz sua marca parecer pouco profissional. O sistema de camadas, os controles por propriedade na barra de ferramentas, a pré-visualização em tempo real no canvas e o suporte a atalhos de teclado se somam a um nível de controle realmente comparável ao de softwares desktop dedicados.',
            'Confiabilidade importa porque seu trabalho ainda não publicado é valioso. Saber que suas imagens nunca trafegam pela internet até um servidor de terceiros significa que você pode marcar fotos de clientes, imagens de produtos não lançados e trabalhos criativos sensíveis sem qualquer preocupação com tratamento de dados, falhas do lado do servidor ou mudanças de política de um provedor de nuvem.',
            'Seja para adicionar um aviso de copyright rápido a uma única foto ou para processar uma sessão inteira com 200 imagens antes de compartilhar uma galeria de cliente, a ferramenta Watermark Image da Photremium oferece os recursos para fazer isso direito — totalmente grátis, totalmente privada e com flexibilidade criativa suficiente para fazer a marca d\'água parecer parte da imagem, e não algo colado por cima.',
            'Acesse photremium.com/watermark-image e experimente. Sua primeira imagem com marca d\'água está literalmente a trinta segundos de distância.',
            'A Photremium oferece um conjunto de ferramentas de edição e processamento de imagens baseadas no navegador. Todas as ferramentas rodam localmente no seu navegador — suas imagens permanecem no seu dispositivo.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Gerador de QR Code — Criar e Personalizar Grátis | photremium.com',
      inputDesc: 'Gere QR codes personalizados para URLs, texto, WiFi, contatos, e-mail e localizações no Google Maps. Personalize cores, formas, molduras e logotipos.',
      inputKeywords: 'gerador de qr code, criar qr code, qr code personalizado, criador de qr code, qr code grátis',
      customizeTitle: 'Personalizar QR Code — photremium.com Gerador de QR Code',
      customizeDesc: 'Personalize o estilo, cor, moldura e logotipo do seu QR code. Baixe em PNG, JPG, SVG, WEBP ou PDF.',
      customizeKeywords: 'personalizar qr code, estilo qr code, cores qr code, logotipo qr code',
    },
    title: 'Gerador de QR Code',
    desc: 'Gere, personalize e baixe QR codes para URLs, texto, WiFi, contatos, e-mail e mapas.',
    generate: 'Gerar',
    tabUrl: 'Link / URL',
    tabText: 'Texto',
    tabWifi: 'WiFi',
    tabContact: 'Contato',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    generateCustomize: 'Gerar e Personalizar',
    downloadFormatBtn: 'Baixar {format}',
    pngDesc: 'Sem perdas, suporte a transparência',
    jpgDesc: 'Formato de arquivo popular/universal',
    webpDesc: 'Formato moderno, melhor qualidade/tamanho',
    svgDesc: 'Gráfico vetorial escalável',
    pdfDesc: 'Documento pronto para impressão',
    lat: 'Latitude:',
    lng: 'Longitude:',
    qrCode: 'QR Code',
    scanMe: 'ESCANEAR',
    scanHere: 'ESCANEAR AQUI',
    blog: {
      card1: {
        title: '1. O que é um QR Code?',
        intro1: 'A forma completa de QR Code é “Quick Response code”. Como as informações armazenadas nele são decodificadas muito rapidamente, ele é chamado de código de resposta rápida (QR).',
        intro2: 'QR Code é um código digital bidimensional legível apenas por máquinas. Os dados nele não podem ser lidos diretamente por humanos. Ele contém blocos para armazenar informações como texto, números de contato, links e localizações do Google Maps, etc.',
        inventionTitle: 'Como o QR Code foi inventado:',
        inventionText: 'O QR Code foi inventado em 1994. Masahiro Hara e sua equipe trabalhavam em uma empresa japonesa chamada Denso Wave, que fabricava peças automotivas para a Toyota. Eles queriam um código que armazenasse muito mais informação do que um código de barras comum, e então inventaram o QR Code.',
        keyFeaturesTitle: 'Principais recursos de um QR Code',
        keyFeatures: [
          {
            title: 'Como o QR funciona',
            text: 'Você insere o texto ou link para gerar o QR Code. O gerador cria módulos quadrados de acordo com a informação. Cada quadrado representa um bit, e cada bit armazena um caractere.',
          },
          {
            title: 'Estrutura do QR Code',
            text: 'Um QR Code contém três quadrados grandes para identificar a orientação do código e pequenos quadrados para armazenar os bits (informações).',
          },
          {
            title: 'Capacidade de dados do QR Code',
            text: 'Normalmente, um QR Code armazena mais informação do que um código de barras. O QR Code é basicamente uma versão avançada e bidimensional do código de barras. Um QR Code armazena cerca de 200 caracteres. Ele também pode armazenar 400 caracteres, mas pode ficar difícil de escanear. Armazenar mais de 400 caracteres pode resultar em um QR Code muito complexo, que na maioria dos casos não será escaneado.',
          },
          {
            title: 'Detecção de erros em QR Codes',
            text: 'Um QR Code ainda pode ser escaneável se parte das informações estiver arranhada ou alguns bits forem alterados. O QR Code usa a técnica de detecção/correção Reed-Solomon para identificar e corrigir erros.',
          },
        ],
        errorTitle: 'Nível de correção de erro do QR Code:',
        errorIntro: 'Diferentes técnicas de detecção e correção de erro são usadas em diferentes casos, como descrito abaixo:',
        errorHeaders: {
          level: 'Nível',
          recovery: 'Capacidade de recuperação',
          bestUse: 'Melhor caso de uso',
        },
        errorRows: [
          {
            level: 'Baixo (L)',
            recovery: '~7%',
            useCases: [
              'Essa técnica de correção é usada quando o QR Code é exibido em telas digitais, sites ou em ambiente limpo.',
              'Quando o QR Code é gerado para informações pequenas como Gmail, número de contato ou texto curto.',
            ],
          },
          {
            level: 'Médio (M)',
            recovery: '~15%',
            useCases: [
              'Para panfletos e cartazes instalados em ambiente limpo, quando o risco de dano é mínimo.',
            ],
          },
          {
            level: 'Quartil (Q)',
            recovery: '~25%',
            useCases: [
              'Quando o QR Code será instalado em ambiente agressivo, como fábrica/área externa.',
              'Também quando um logo pequeno é necessário no centro, pois cobre alguns bits. Nesse caso, essa correção é necessária.',
            ],
          },
          {
            level: 'Alto (H)',
            recovery: '~30%',
            useCases: [
              'Usado quando existe possibilidade de dano pesado no QR Code.',
              'Quando logos grandes cobrem o centro do QR Code.',
              'Também quando é necessário muito estilo visual no QR Code.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Por que escolher nosso gerador de QR Code?',
        intro: 'Nosso gerador de QR Code torna a criação extremamente rápida, segura e fácil. Você pode personalizar seu código para deixá-lo mais avançado, profissional e alinhado ao tema do seu negócio. Todas as personalizações, desde cores até instalação de logo no QR Code, são oferecidas gratuitamente para sempre.',
        strengths: [
          {
            title: 'Personalização profissional:',
            text: 'Você pode gerar e personalizar quantos QR Codes precisar sem custo. Todos os recursos são totalmente gratuitos. Você pode aplicar cores em gradiente, diferentes formas para os módulos, logos personalizados e muitos outros recursos.',
          },
          {
            title: 'Suporte a múltiplos formatos:',
            text: 'Nosso gerador oferece vários formatos de download para sua praticidade. Você só precisa selecionar o formato antes de baixar. Atualmente oferecemos estes formatos:',
          },
          {
            title: 'Templates prontos:',
            text: 'Você pode usar gradientes e molduras prontas que deixam seu QR Code mais profissional.',
          },
          {
            title: 'Suporte a logo personalizado:',
            text: 'Você também pode enviar o logo da sua marca, que se encaixa automaticamente no centro do QR Code. Também é possível selecionar um logo da biblioteca interna com mais de 30 opções.',
          },
          {
            title: 'Pré-visualização ao vivo:',
            text: 'Durante a personalização, você pode ver todas as alterações em um painel de pré-visualização em tempo real.',
          },
          {
            title: 'Indicador de leitura:',
            text: 'Ao escolher as cores, alertas e indicadores mostram quando a combinação selecionada pode ficar difícil de escanear.',
          },
        ],
        formatHeaders: {
          srNo: 'Nº',
          formats: 'Formatos',
          description: 'Descrição',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Sem perdas, suporte a transparência' },
          { no: '2', format: 'JPG', description: 'Formato popular e universal' },
          { no: '3', format: 'WEBP', description: 'Formato moderno, melhor qualidade/tamanho' },
          { no: '4', format: 'SVG', description: 'Gráfico vetorial escalável' },
          { no: '5', format: 'PDF', description: 'Documento pronto para impressão' },
        ],
      },
      card3: {
        title: '3. Guia passo a passo:',
        step1Intro: 'Primeiro, selecione a categoria do QR Code que você quer gerar. Seja para contato, mapa, link ou texto. Atualmente, nosso gerador oferece estas categorias:',
        categories: ['Link / URL', 'Texto', 'WiFi', 'Contato', 'Gmail', 'Google Maps'],
        step2: 'Depois de selecionar a categoria, cole suas informações na caixa de texto correspondente.',
        step3Intro: 'Em seguida, clique em Gerar e Personalizar para abrir o painel de personalização. Nesse painel você verá uma subnavegação com as opções abaixo:',
        options: [
          {
            title: 'Estilo e forma:',
            text: 'Nesta seção, você pode alterar as formas dos módulos para vários estilos, como cantos arredondados, pontos, barras horizontais, barras verticais, quadrados pequenos e muitos outros.',
          },
          {
            title: 'Cor:',
            text: 'Você pode selecionar as cores personalizadas de fundo e frente nesta seção. Para criar QR Code com gradiente, você pode ativar o gradiente e aplicar uma opção da biblioteca integrada ou criar o seu facilmente. Também é possível mudar o ângulo do gradiente linear. Gradiente radial também é suportado. Você pode adicionar várias cores para criar um efeito profissional.',
          },
          {
            title: 'Molduras:',
            text: 'Aqui, você pode selecionar uma moldura ideal para seu QR Code. Todas as molduras se ajustam automaticamente ao código. Basta escolher uma da biblioteca integrada.',
          },
          {
            title: 'Logo:',
            text: 'Após escolher a moldura, você pode selecionar um logo que é ajustado automaticamente no centro do QR Code. O upload do seu logo de marca também é suportado.',
          },
          {
            title: 'Templates:',
            text: 'Se você não quiser escolher estilo, forma, cor e moldura separadamente, pode aplicar templates prontos no seu QR Code. Vários templates premium são fornecidos gratuitamente para sempre.',
          },
          {
            title: 'Formato de arquivo:',
            text: 'Por fim, você deve selecionar o tipo de arquivo em que deseja baixar o QR Code. Vários formatos comuns são suportados, incluindo PNG, WEBP, SVG e PDF, etc.',
          },
          {
            title: 'Editar dados do QR:',
            text: 'Você também pode editar os dados do QR sem perder as personalizações selecionadas.',
          },
        ],
        finalStep: 'Depois, basta clicar no botão de download e o QR Code, exatamente de acordo com suas personalizações e no formato selecionado, será baixado instantaneamente sem custo.',
      },
      card4: {
        title: '4. Benefícios:',
        intro: 'O QR Code conecta o mundo físico à experiência digital. É a forma mais rápida de compartilhar links, contato ou localização. Você só precisa escanear o QR Code para acessar a informação instantaneamente. Por isso, ele é muito popular nos negócios e no mundo digital por economizar tempo e ser altamente útil.',
        benefits: [
          {
            title: 'Suporte vitalício:',
            text: 'QR Codes funcionam para sempre, sem expiração. Eles entregam instantaneamente as informações armazenadas quando você escaneia. Como armazenam instruções digitais fixas, nunca perdem suas informações.',
          },
          {
            title: 'Suporte offline:',
            text: 'Você pode escanear o QR Code mesmo sem internet. A câmera do celular decodifica os padrões do QR Code e mostra as informações armazenadas.',
          },
          {
            title: 'Custo zero:',
            text: 'Como esses códigos não exigem redirecionamento por servidor nem recursos extras, são gratuitos para sempre.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'Leitor de QR Code — Escanear QR Codes por Câmera ou Imagem | photremium.com',
      desc: 'Escaneie QR codes instantaneamente com a câmera ou enviando uma imagem. Detecte URLs, texto, WiFi, contatos e mais. Grátis, rápido, privado.',
      keywords: 'leitor de qr code, escanear qr code, leitor qr, leitor de qr code online, ler qr de imagem, leitor qr de câmera',
    },
    title: 'Leitor de QR Code',
    desc: 'Escaneie QR codes instantaneamente com a câmera ou envie uma imagem.',
    generateQrCode: 'Gerar QR code',
    scan: 'Escanear',
    cameraScanner: 'Leitor por câmera',
    uploadImage: 'Enviar imagem',
    copied: 'Copiado!',
    copy: 'Copiar',
    share: 'Compartilhar',
    scanAgain: 'Escanear novamente',
    blog: {
      tocTitle: 'Conteúdo',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Por que usar um scanner de QR code?',
          paragraphs: [
            'Um scanner de QR code é basicamente uma câmera de celular que decodifica as informações armazenadas no QR code. Você só precisa apontar a câmera para o QR code; independentemente da orientação, ele lê os padrões específicos, detecta erros, corrige os erros quando necessário e exibe as informações contidas nele.',
          ],
          listTitle: 'Tipos de scanners de QR code:',
          bullets: [
            'Scanner de QR code baseado na web: Você pode escanear QR code com scanners online compatíveis com seu navegador. Você pode acessar as informações pela câmera ou pelo upload da imagem. Para redirecionamento automático e outros recursos avançados, visite https://photremium.com.',
            'Câmeras de celular: Alguns celulares modernos têm scanner de QR code integrado no app de câmera nativo. Eles conseguem buscar e decodificar as informações apenas escaneando o QR code com a câmera.',
            'Apps: Existem apps feitos especificamente para escanear QR codes. Porém, para redirecionamento avançado e vários outros recursos, você pode instalar o app por este link gratuitamente: https://photremium.com.',
            'Dispositivos de hardware: Alguns dispositivos físicos também são feitos para escanear QR codes. Esses dispositivos são muito usados em grandes shoppings para cobrança de itens.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Por que escolher nosso scanner de QR code?',
          paragraphs: [
            'Você pode explorar vários recursos avançados, incluindo redirecionamento e cópia do conteúdo decodificado do QR code. Você também encontra muitos outros recursos interessantes no nosso scanner de QR code, como:',
          ],
          bullets: [
            'Alta velocidade: Nosso scanner de QR code torna a decodificação extremamente rápida. Você só precisa escanear o QR code e a ferramenta mostra as informações instantaneamente com opção avançada para copiar texto/link, abrir se detectar um link ou salvar automaticamente se detectar um contato.',
            'Sem instalação: Você não precisa instalar nenhum app separado para usar nosso scanner de QR code. Você pode acessar esta ferramenta no navegador local gratuitamente.',
            'Acesso multiplataforma: Você pode acessar em qualquer dispositivo. Sem preocupação com versão de sistema operacional ou outros requisitos. É compatível com todas as versões e dispositivos.',
            'Suporte a todos os formatos: Todos os formatos de dados que podem ser armazenados em QR code são suportados pela nossa ferramenta, incluindo texto simples, WiFi, URLs, contatos, Gmail e Google Maps, etc.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Guia passo a passo:',
          steps: [
            {
              heading: '1. Antes de tudo, escolha um método para escanear o QR code. Existem dois métodos para isso:',
              subSteps: [
                {
                  heading: 'i. Método da câmera',
                  paragraphs: [
                    'Você pode escanear o QR code usando a câmera do seu dispositivo mesmo em notebook, PC ou qualquer dispositivo que tenha câmera simples. Ao clicar no botão “Iniciar câmera”, aparecerá uma solicitação de permissão; permita o acesso para este site usar sua câmera para escanear QR. Se você negou por engano ou a solicitação não apareceu, pode conceder acesso manualmente seguindo estes passos:',
                  ],
                  notes: [
                    '➔ Para Chrome (Android / Desktop):',
                    '1. Clique nos três pontos',
                    '2. Vá em Configurações',
                    '3. (Pule esta etapa no Android) Privacidade e segurança',
                    '4. Clique em Configurações do site',
                    '5. Depois, na seção de permissões, clique em Câmera',
                    '6. Encontre a URL do nosso site: https://photremium.com/qr-code-scanner',
                    '7. Permita a câmera no menu suspenso.',
                    '➔ Para Safari (iPhone / iOS):',
                    '1. Toque no ícone AA ou Ajustes do site na barra de endereço.',
                    '2. Selecione Ajustes do Site.',
                    '3. Toque em Câmera e escolha Permitir.',
                    '4. Se ainda estiver bloqueado: vá em Ajustes do iPhone > Safari > Câmera e defina como Perguntar ou Permitir.',
                  ],
                },
                {
                  heading: 'ii. Método da galeria',
                  paragraphs: [
                    'Você pode enviar a imagem de um QR code para acessar as informações. Clique no botão “Escanear da galeria”, e o explorador de arquivos será aberto. Depois, selecione a imagem do QR code. Todos os formatos de imagem são suportados, como .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz e .xbm, etc.',
                  ],
                },
              ],
            },
            {
              heading: '2. Quando você selecionar o QR code, todas as informações serão exibidas; permitindo copiar, compartilhar ou abrir o link, se detectado. Você também pode escanear novamente, se quiser.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Benefícios do scanner de QR code:.',
          paragraphs: [
            'O scanner de QR code oferece vários benefícios neste mundo digital. Ele facilita pagamentos, verificações e acesso à informação de forma rápida, até mesmo no modo offline.',
          ],
          bullets: [
            'Acesso instantâneo à informação: Escanear o QR code fornece as informações em milissegundos. Ele decodifica padrões, detecta erros e os remove rapidamente, oferecendo uma experiência extremamente rápida ao usuário.',
            'Comunicação sem atrito: Nesta era de avanço, existe grande necessidade de comunicação rápida e segura para pequenas informações como dados bancários e detalhes de produtos, etc. O scanner de QR code resolve isso, pois pagamentos são feitos ao escanear um QR code. Além disso, o Google verifica celular via QR ao criar uma nova conta no notebook.',
            'E-Tickets: Em rodoviárias, estações ferroviárias ou aeroportos, você pode verificar seus bilhetes facilmente sem esperar em filas por muito tempo. Além disso, scanners de QR code são instalados em vários pontos dos aeroportos para evitar filas. Isso também minimiza a necessidade de funcionários, economizando automaticamente o orçamento da companhia aérea.',
            'Autenticação de produto: Marcas avançadas e de alto padrão colocam QR code em seus produtos. O cliente pode escanear esse QR code para verificar a autenticidade do produto, se é original ou não.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Ferramenta Desfocar Rosto — Desfocar Rostos em Imagens Online | photremium.com',
      uploadDesc: 'Desfoque rostos nas suas imagens automaticamente com detecção de rostos por IA. Escolha a intensidade do desfoque, forma ou sobreposiciões de emoji. 100% gratuito, rápido e privado.',
      uploadKeywords: 'desfocar rosto, desfocar rostos, detecção de rosto, ferramenta de privacidade, desfocar rosto online grátis',
      workspaceTitle: 'Ferramenta Desfocar Rosto — Desfocar Rostos em Imagens Online | photremium.com',
      workspaceDesc: 'Desfoque rostos nas suas imagens automaticamente. 100% gratuito, rápido e privado.',
      workspaceKeywords: 'desfocar rosto, desfocar rostos, detecção de rosto',
    },
    title: 'Desfoque de Rosto',
    desc: 'Detecte e desfoque rostos automaticamente nas imagens para maior privacidade.',
    toBlurFaces: 'Desfocar rostos',
    detecting: 'Detectando...',
    autoDetectFaces: 'Detectar rostos automaticamente',
    blur: 'Desfoque',
    emoji: 'Emoji',
    blurIntensity: 'Intensidade do desfoque',
    strength: 'Intensidade',
    clearAllRegions: 'Limpar todas as regiões',
    processingDots: 'Processando...',
    downloadBlurred: 'Baixar imagem com desfoque',
    downloadNImages: 'Baixar {n} imagens',
    downloadAll: 'Baixar tudo',
    removeRegion: 'Remover região',
    region: 'Região',
    notAllEdited: 'Nem todas as imagens editadas',
    editedXofY: 'Você editou {edited} de {total} imagens.',
    nextImage: 'Próxima imagem',
  },

  faqData: {
    imageConverter: [
      { q: 'Quais formatos de imagem são suportados para conversão?', a: 'Suportamos JPG, PNG, WEBP, SVG, GIF, BMP, ICO e TIFF. Você pode converter entre esses formatos instantaneamente no seu navegador.' },
      { q: 'A qualidade da imagem será afetada durante a conversão?', a: 'Para formatos sem perda como PNG, a qualidade é totalmente preservada. Para formatos com perda como JPG e WEBP, usamos configurações de codificação otimizadas.' },
      { q: 'Existe algum limite de tamanho ou quantidade de arquivos?', a: 'Não há limite rígido. Você pode enviar várias imagens de uma vez e convertê-las em lote. Tudo roda localmente no seu navegador.' },
      { q: 'Meus dados estão seguros? As imagens são enviadas para um servidor?', a: 'Com certeza. Todo o processamento ocorre 100% no seu navegador. Suas imagens nunca saem do seu dispositivo.' },
      { q: 'Posso converter imagens PNG transparentes para JPG?', a: 'Sim. Como JPG não suporta transparência, as áreas transparentes serão preenchidas com fundo branco por padrão.' },
    ],
    imageCompressor: [
      { q: 'Comprimir a imagem reduz a qualidade?', a: 'Não, a compressão não afeta a qualidade até que você ultrapasse os limites recomendados. Os indicadores de qualidade ajudam assim: i. Compressão de 1 a 40%: indicador verde com mensagem “Boa qualidade”. ii. Compressão de 41 a 60%: indicador amarelo com mensagem “Qualidade normal”. Essa faixa é recomendada para ótimos resultados. iii. Compressão de 61 a 100%: o sistema mostra alerta vermelho com mensagem “Qualidade ruim”. Nessa faixa a perda de qualidade pode ficar visível.' },
      { q: 'Quais formatos de imagem são suportados para compressão?', a: 'Nossa ferramenta de compressão suporta todos estes formatos:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Posso comprimir várias imagens ao mesmo tempo?', a: 'Sim, com certeza. Você pode comprimir várias imagens (até 100+) de uma vez, se o seu dispositivo suportar. Como a compressão usa recursos do sistema, lotes grandes funcionam melhor em aparelhos mais potentes. Em dispositivos mais simples, você pode comprimir em etapas — a ferramenta continua gratuita, sem limite de uso.' },
      { q: 'Vocês armazenam ou enviam nossas imagens para servidores?', a: 'Não. Nós nunca enviamos nem armazenamos suas imagens em nossos servidores. Tudo é comprimido localmente no seu navegador. Suas imagens nunca saem do seu dispositivo.' },
      { q: 'Esta ferramenta de compressão é gratuita?', a: 'Sim. Nosso compressor é totalmente gratuito para sempre. Não cobramos nada, não há taxas ocultas e todos os recursos — inclusive compressão em lote — são grátis.' },
    ],
    cropImage: [
      { q: 'Recortar a imagem reduzirá sua qualidade?', a: 'Não, recortar a imagem nunca afetará a qualidade visual da imagem de forma alguma. Recortar a imagem apenas descarta as partes indesejadas. Nunca altera os pixels da parte da imagem a ser recortada. Portanto, você pode recortar suas imagens na qualidade original sem nenhum dano de pixels.' },
      { q: 'Quais formatos de imagem são suportados para o recortador de imagens?', a: 'Você pode selecionar qualquer imagem de qualquer formato, pois nossa ferramenta de recorte de imagens oferece quase todos os formatos de imagem. Eles estão listados abaixo:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Minhas imagens são enviadas para o seu servidor?', a: 'Não, todo o processamento será feito no seu navegador local. Suas imagens nunca serão enviadas para nosso servidor, pois elas nunca saem do seu dispositivo. Portanto, você pode recortar suas imagens pessoais com nosso recortador de imagens sem nenhum risco.' },
      { q: 'Posso recortar várias imagens de uma vez?', a: 'Sim, você pode recortar várias imagens (até 100+) de uma vez se o seu sistema suportar. Como recortar imagens usa os recursos do seu sistema, se você tiver um notebook, PC ou celular de alto desempenho, poderá recortar muitas imagens de uma vez. Se você tiver um dispositivo de baixo desempenho, poderá recortar imagens em lotes, pois esta ferramenta é gratuita mesmo se você recortar várias imagens de uma vez.' },
      { q: 'Esta ferramenta de recorte de imagens é gratuita?', a: 'Sim, esta ferramenta de recorte de imagens é totalmente gratuita para sempre. Você pode acessar esta ferramenta em qualquer lugar, a qualquer hora e usando qualquer dispositivo. Você não apenas terá um design responsivo para todos os dispositivos, como também nunca será solicitado a pagar por nenhum recurso premium. Todos os recursos são totalmente gratuitos, sem taxas ocultas.' },
    ],
    resizeImage: [
      { q: 'Posso redimensionar várias imagens de uma vez?', a: 'Com certeza. Nosso redimensionador permite processar várias imagens simultaneamente. Você pode enviar quantas imagens seu dispositivo suportar, e o mecanismo de IA processa tudo de uma vez. Em dispositivos mais fracos, o ideal é fazer em lotes para evitar travamentos. Tudo ocorre localmente, sem envio para servidor, preservando a privacidade.' },
      { q: 'Esta ferramenta de redimensionamento é gratuita?', a: 'Sim, esta ferramenta é totalmente gratuita para sempre. Não há assinatura paga para recursos premium. Também não existem cobranças ocultas ao baixar imagens redimensionadas.' },
      { q: 'Redimensionar imagem reduz a qualidade?', a: '✅Decrease Size (downscale): Reduzir o tamanho da imagem não diminui a qualidade visual. Em muitos casos, a imagem redimensionada pode até parecer mais nítida. Portanto, reduzir para tamanhos menores normalmente não causa perda de qualidade.\n❌Increase Size (upscale): Aumentar a imagem além do tamanho original pode afetar a qualidade visual. Quanto maior o aumento, maior a chance de perda de qualidade.' },
      { q: 'Esta ferramenta é segura?', a: 'Sim, nossa ferramenta é segura, especialmente para imagens pessoais e sensíveis. Todo o processamento ocorre localmente no seu dispositivo e nenhum dado sai dele. Você pode redimensionar sem risco de privacidade.' },
      { q: 'Quais formatos de imagem são suportados?', a: 'Nosso redimensionador suporta todos os formatos de imagem. Você pode selecionar imagens nos seguintes formatos:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Como funciona a remoção de fundo?', a: 'Usamos um modelo de IA avançado que roda diretamente no seu navegador para detectar o objeto e separá-lo do fundo, gerando um PNG transparente.' },
      { q: 'Funciona com fundos complexos?', a: 'Sim. O modelo de IA lida com uma grande variedade de cenas. Os melhores resultados são com contraste claro entre objeto e fundo.' },
      { q: 'Posso remover o fundo de várias imagens de uma vez?', a: 'Sim. Faça upload de várias imagens e a ferramenta as processará sequencialmente. Baixe todos os resultados como ZIP.' },
      { q: 'Qual é o formato de saída?', a: 'A saída é sempre um arquivo PNG com fundo transparente.' },
      { q: 'Minhas imagens são enviadas para um servidor?', a: 'Não. O modelo de IA roda inteiramente no seu navegador usando WebAssembly.' },
    ],
    watermarkImage: [
    { q: '1. A ferramenta de marca d\'agua da Photremium é totalmente gratuita?', a: 'Sim, a ferramenta em photremium.com/watermark-image é gratuita e não requer conta ou assinatura. Você pode aplicar marca d\'agua a imagens individuais ou lotes inteiros sem paywall e sem limites artificiais.' },
    { q: '2. Quantas imagens posso processar ao mesmo tempo?', a: 'A ferramenta suporta processamento em lote. Arraste uma pasta inteira ou selecione muitos arquivos — o limite prático depende da memória do seu dispositivo.' },
    { q: '3. Quais formatos de imagem são suportados?', a: 'Suporta formatos lidos pelo File API do navegador: JPEG, JPG, PNG, WEBP, GIF (estático), BMP e SVG. A saída mantém o formato de entrada.' },
    { q: '4. A marca d\'agua ficará igual em imagens com resoluções diferentes?', a: 'Sim. O motor de reposicionamento proporcional calcula posição e escala relativas para cada imagem, mantendo a aparência da marca d\'agua no lote.' },
    { q: '5. Posso usar meu próprio logotipo em vez de texto?', a: 'Sim. O botão "Add Image" permite enviar um PNG com fundo transparente, que preserva a transparência e é usado como camada de marca d\'agua.' },
    { q: '6. Como deixar a marca d\'agua semitransparente?', a: 'Selecione a camada da marca d\'agua no canvas e ajuste o slider de opacidade. 30–50% geralmente funciona bem para um resultado discreto.' },
    { q: '7. Posso adicionar várias camadas de marca d\'agua em uma única imagem?', a: 'Sim. O sistema de camadas suporta múltiplas camadas, cada uma com suas próprias configurações.' },
    { q: '8. O que faz a função tiling e quando usar?', a: 'Tiling repete a marca d\'agua em uma grade por toda a imagem — útil para impedir o uso não autorizado do conteúdo.' },
    { q: '9. A ferramenta funciona em dispositivos móveis?', a: 'Sim — a interface é responsiva: miniaturas viram uma faixa rolável, o painel de configurações aparece como drawer inferior e os controles suportam toque.' },
    { q: '10. Minhas imagens são privadas e são enviadas para algum servidor?', a: 'As imagens permanecem no seu dispositivo. Todo o processamento é local no navegador usando Canvas API; não há upload dos dados de imagem.' },
    ],
    qrCodeGenerator: [
      { q: 'Este QR Code expira?', a: 'Não, esses QR Codes não expiram e garantem suporte vitalício. Como armazenam instruções codificadas em forma de bits dentro de módulos quadrados, as informações armazenadas neles não podem ser removidas. Você pode acessar as informações escaneando com qualquer câmera mesmo depois de anos.' },
      { q: 'Por que meu QR Code não está escaneando?', a: 'Seu QR Code pode falhar por estes motivos: i. Baixo contraste: se você escolher cores de fundo e frente muito parecidas, isso afeta a visibilidade do QR Code e pode causar falha na leitura. Nossa ferramenta orienta você durante a personalização sobre baixo contraste e outros problemas de leitura. ii. Dados muito grandes: se você gerar um QR Code para um texto muito longo, ele fica muito complexo e pode causar dificuldade no escaneamento. Um validador de comprimento de texto orienta sobre o tamanho ideal durante a geração. iii. Impressão borrada: certifique-se de baixar seu QR Code em alta resolução, como PNG ou SVG, formatos já suportados pela nossa ferramenta.' },
      { q: 'Posso adicionar logo no QR Code?', a: 'Com certeza, você pode adicionar um logo personalizado ou selecionar um da biblioteca de logos integrada para o seu QR Code. O logo selecionado será ajustado automaticamente no centro do QR Code.' },
      { q: 'Como posso escanear o QR Code?', a: 'Você pode escanear o QR Code usando a câmera do celular. Mas para redirecionamento automático de links e muitos recursos avançados, você pode usar gratuitamente nosso scanner em https://photremium.com/qr-code-scanner.' },
      { q: 'Quantos QR Codes posso gerar gratuitamente?', a: 'ILIMITADOS! Você pode gerar vários QR Codes de graça. Todos os recursos, personalizações e templates são gratuitos para sempre. Não é necessário assinar para usar recursos premium.' },
      { q: 'Preciso fazer login/cadastro para gerar QR Code?', a: 'Não. Basta inserir seu texto, gerar o QR Code e baixar após personalizar. Não é necessário login nem cadastro, pois todos os recursos podem ser acessados gratuitamente.' },
    ],
    qrCodeScanner: [
      { q: 'Posso escanear QR code a partir de imagens salvas e capturas de tela?', a: '**Sim**, você pode escanear um QR code a partir de imagens salvas ou capturas de tela. Nosso scanner de QR code https://photremium.com/qr-code-scanner permite escanear QR code da galeria. Você só precisa selecionar a imagem e receberá todas as informações decodificadas daquele QR code.' },
      { q: 'Preciso instalar aplicativo para usar o scanner de QR code?', a: '**Não**, nosso scanner de QR code baseado na web permite escanear QR code sem precisar instalar nenhum app. Você pode acessar nosso scanner avançado em qualquer dispositivo gratuitamente.' },
      { q: 'Por que o scanner não está reconhecendo o QR code?', a: 'Seu QR code não está sendo escaneado por algum dos seguintes motivos: i. Luz insuficiente: Escanear o QR code em pouca luz pode causar dificuldade. Ligue a lanterna e aumente o brilho se estiver escaneando de uma tela. ii. Distância: Escanear de distância inadequada também causa problemas. A distância ideal para escanear QR code é de aproximadamente 10 polegadas (25cm). iii. Lentes da câmera sujas: O QR code também pode falhar por lentes sujas. Limpe as lentes antes de escanear. “Você vê uma grade em caixa no scanner? Basta encaixar o QR code dentro dela para escanear com sucesso.”' },
      { q: 'Esta ferramenta escaneia QR code invertido ou colorido?', a: '**Sim**, você pode escanear QR em qualquer cor ou orientação. Porém, se o contraste entre cor de fundo e primeiro plano for baixo, isso pode dificultar o escaneamento.' },
      { q: 'Esta ferramenta é gratuita?', a: '**Sim**, esta ferramenta é totalmente gratuita. Você pode escanear QR codes ilimitados grátis para sempre.' },
    ],
    faceBlur: [
      { q: 'Como funciona a detecção de rostos?', a: 'Usamos um modelo de detecção de rostos com IA que roda diretamente no seu navegador. Ele identifica rostos na imagem para que você possa aplicar desfoque.' },
      { q: 'Posso escolher quais rostos desfocar?', a: 'Sim. Após a detecção, cada região de rosto é destacada e você pode selecionar quais desfocar e ajustar a intensidade.' },
      { q: 'Quais estilos de desfoque estão disponíveis?', a: 'Você pode escolher entre desfoque gaussiano, pixelação ou preenchimento de cor sólida, com intensidade totalmente ajustável.' },
      { q: 'Posso desfocar rostos em várias imagens de uma vez?', a: 'Sim. Faça upload de várias imagens, configure as regiões de desfoque e baixe todas as imagens processadas.' },
      { q: 'Minhas fotos são enviadas para um servidor remoto?', a: 'Não. O modelo de IA roda no seu navegador com WebAssembly. Suas fotos nunca são enviadas para nenhum servidor.' },
    ],
    photoEditor: [
      { q: 'Quais funções de edição estão disponíveis?', a: 'Você pode ajustar brilho, contraste, saturação, aplicar filtros, adicionar texto, sobreposições, molduras, figurinhas e muito mais, tudo no seu navegador.' },
      { q: 'Posso desfazer e refazer alterações?', a: 'Sim. O editor suporta histórico completo de desfazer/refazer.' },
      { q: 'Quais formatos posso editar e exportar?', a: 'Você pode editar JPG, PNG, WEBP e outros formatos comuns. A imagem editada pode ser exportada no formato e qualidade de sua preferência.' },
      { q: 'O editor funciona em celulares?', a: 'Sim. O editor é totalmente responsivo e compatível com toque.' },
      { q: 'Minhas imagens são armazenadas nos seus servidores?', a: 'Não. Toda a edição é feita localmente. Suas imagens nunca saem do seu dispositivo.' },
    ],
  },
};
export default ptBr;